<template>
  <div class="banner-sizes-selector">
    <el-checkbox-group v-model="selectedSizes" @change="update">
      <el-checkbox
        v-for="size in availableSizes"
        :key="size.id"
        :label="size.id"
        :value="size.id"
      >
        {{ size.label }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from 'vue'
import { Size, SizeLabels, AdaptiveBannerSize } from '@/api/types'

export default defineComponent({
  name: 'BannerSizesSelector',
  props: {
    modelValue: {
      type: Array as () => Size[],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    includeAdaptive: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const selectedSizes = ref<Size[]>(props.modelValue || [])

    const availableSizes = computed(() => {
      const sizes = [...SizeLabels]

      if (props.includeAdaptive) {
        sizes.push(AdaptiveBannerSize)
      }

      return sizes
    })

    const update = (newValue: Size[]) => {
      context.emit('update:modelValue', newValue)
    }

    watch(
      () => props.modelValue,
      (newValue) => {
        selectedSizes.value = newValue || []
      }
    )

    return {
      selectedSizes,
      availableSizes,
      update
    }
  }
})
</script>

<style lang="scss" scoped>
.banner-sizes-selector {
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .el-checkbox {
    margin-right: 0;
    margin-bottom: 8px;
  }
}
</style>
